import timer from "../../library/util/timer";
import checkmateApi from "../axios/checkmateApi"

export const getTaxonomyList = async () => {
    const response = checkmateApi({
        method: 'GET',
        url: 'taxonomy'
    });
    return response;
}

export const getTaxonomyDetails = async (taxonomyId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `taxonomy/${taxonomyId}`
    })
    return response;
}